import { useReactTable, getCoreRowModel, flexRender, createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useEffect, useState } from "react";
import * as FileService from "../../services/fileService";
import IntegrationAnnouncementService from "../../services/integrationAnnouncementService";
import SettingsService from "../../services/settingsService";
import Form from "react-bootstrap/Form";

import { toast } from "react-toastify";
import config from "../../config.json";
import dictionary from "../../PL.json";
import Tags from "../tags";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ConfirmationSwitch from "./confirmationSwitch";
import AddOrEditAnnouncementIntegrationModal from "../AddOrEditAnnouncementIntegrationModal";
import ConfirmationIconWithToolTip from "./confirmationIconWithToolTip";

import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import AddVirtualModuleModal from "../AddVirtualModuleModal";

const columnHelper = createColumnHelper();

const VirtualModuleTable = ({ vm, files, onChange, onEnableChange }) => {
  const [showAddOrEdit, setShowAddOrEdit] = useState(false);
  const [selectedVM, setSelectedVM] = useState(null);

  useEffect(() => {
    console.log(vm)
  }, [vm]);

  const setEdit = (id) => {
    if (id === null) {
      setSelectedVM(null);
    } else {
      const selected = vm.find((item) => item.id === id);
      setSelectedVM(selected);
    }
    setShowAddOrEdit(true);
  };

  const columns = useMemo(
    () => [
      columnHelper.accessor("id", {
        header: "lp",
        cell: (cell) => cell.getValue(),
      }),

      columnHelper.accessor("name", {
        header: dictionary.integration.tabs_announcements.table.name,
        cell: (cell) => cell.getValue(),
      }),
      columnHelper.accessor("file", {
        header: "Plik",
        cell: (cell) => {

          let fileId = cell.getValue()?._id;
          console.log(fileId);
          if (fileId === null || fileId === undefined) {
            return "";
          }
          const file = files.find((f) => f._id === fileId);
          if (file) {
            return file.name;
          }
          return "";
        },
      }),
      columnHelper.accessor("interval", {
        header: "Częstotliwość [minuty]",
        cell: (cell) => cell.getValue(),
      }),
      columnHelper.accessor("zones", {
        header: dictionary.integration.tabs_announcements.table.zones,
        cell: (item) => {
          const zones = item.getValue();
          return (
            <div className="tag-container flex-container__center">
              {zones !== null &&
                zones !== undefined &&
                zones.map((zone) => {
                  return (
                    <div
                      className="tag"
                      key={zone}
                    >
                      <div className="tag__name">{dictionary.integration.tabs_announcements.zoneMASettings[zone]}</div>
                    </div>
                  );
                })}
            </div>
          );
        },
      }),
      columnHelper.accessor("active", {
        header: dictionary.integration.tabs_announcements.table.active,
        cell: (item) => {
          // console.log("item.getValue()", item.getValue());
          return (
            <Form.Check
              key={item.row.original.id + "active"}
              onChange={(event) => onEnableChange(item.row.original.id, event.target?.checked)}
              checked={item.getValue()}
              type="switch"
            />
          );
        },
      }),
      columnHelper.accessor("actions", {
        header: "", //() => {
        // return (
        // <Button onClick={() => setEdit(null)}>{dictionary.integration.tabs_announcements.table.addNew}</Button>
        // );

        cell: (item) => {
          //get rest of row data

          return (
            <>
              <FontAwesomeIcon
                onClick={() => setEdit(item.row.original.id)}
                className="tag__edit color-green my-0 mx-0"
                icon={faEdit}
              />
              {/* <ConfirmationIconWithToolTip
                placement="top"
                info={""}
                label={dictionary.integration.apiKey.saveButton_confirmLabel}
                yesLabel={dictionary.integration.apiKey.saveButton_confirmYesLabel}
                noLabel={dictionary.integration.apiKey.saveButton_confirmNoLabel}
                onClick={() => removeItem(item.row.original._id)}
                className="tag__delete color-red my-0"
                icon={faTrash}
              /> */}
            </>
          );
        },
      }),
    ],
    [vm]
  );

  const table = useReactTable({
    data: vm,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="table-responsive">
      <table className="table mb-0 table-striped table-bordered align-middle text-center">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  colSpan={header.colSpan}
                  className="text-center align-middle"
                >
                  {flexRender(header.column.columnDef.header, header.getContext())}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {vm.length > 0 &&
            table.getRowModel().rows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    className="text-center"
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>

      <AddVirtualModuleModal
        show={showAddOrEdit}
        onHide={() => {
          setShowAddOrEdit(false);
        }}
        vm={selectedVM}
        files={files}
        onSubmit={onChange}
      />
    </div>
  );
};

export default VirtualModuleTable;
